import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import {
  Col, Form, FormControl, FormLabel, Spinner,
} from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../hooks/useAuth';
import useForm from '../hooks/useForm';

import './auth.css';

function SetPassword() {
  const title = 'Set Password';
  const { getMemberNo } = useAuth();
  const memberNo = getMemberNo();
  const { getVToken } = useAuth();
  const vToken = getVToken();
  const [isLoading, setIsLoading] = useState(false);
  const { setPassword } = useAuth();
  const navigate = useNavigate();

  const [catchError, setIsCatchError] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const onSuccess = () => {
    navigate('/login');
    setIsAlert(false);
  };

  const handleSetPassword = async (e, data) => {
    if (data.password.length < 6) {
      setIsCatchError('Password should be min 6 characters');
      setIsError(true);
      return;
    }
    if (data.password !== data.confirmPassword) {
      setIsCatchError('Password does not match');
      setIsError(true);
      return;
    }
    try {
      setIsLoading(true);
      await setPassword(memberNo, vToken, data.password);
      setIsAlert(true);
      setIsLoading(false);
    } catch (err) {
      setIsCatchError(err.message);
      setIsError(true);
      setIsLoading(false);
    }
  };

  const validators = {
    confirmPassword: {
      required: {
        value: true,
        message: 'Password is required',
      },
    },
    password: {
      required: {
        value: true,
        message: 'password is required',
      },
    },
  };

  // Using a custom hook to show how we can build out our own hook.
  const {
    handleChange,
    handleSubmit,
    errors,
  } = useForm({
    onSubmit: handleSetPassword,
    validators,
  });

  const onConfirm = () => {
    setIsAlert(false);
    setIsError(false);
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <main className="container">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>{title}</Breadcrumb.Item>
        </Breadcrumb>
        <h1 className="page-title">{title}</h1>
        <div className="container-auth">
          <Form className="row g-2" noValidate>
            <Form.Group as={ Col } lg="12" controlId="inputPassword">
              <FormLabel>New Password</FormLabel>
              <FormControl type="password"
                           isInvalid={ errors.password }
                           onChange={handleChange('password')}
              />
              <Form.Control.Feedback type="invalid">
                New Password is required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={ Col } lg="12" controlId="inputConfirmPassword">
              <FormLabel>Confirm Password</FormLabel>
              <FormControl type="password"
                           isInvalid={ errors.confirmPassword }
                           onChange={handleChange('confirmPassword')}
              />
              <Form.Control.Feedback type="invalid">
                Confirm Password is required
              </Form.Control.Feedback>
            </Form.Group>
            <div>{Object.keys(errors)
              .map((key) => <div className="text-danger" key={key}>{errors[key]}</div>)}</div>
            <button className="w-100 btn btn-green"
                    disabled={isLoading}
                    onClick={handleSubmit}
            >
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading}/>
              <span className="px-2">Reset Password</span>
            </button>
          </Form>
        </div>
      </main>
      {isAlert
      && <SweetAlert
        success
        title="Password Successfully Updated"
        onConfirm={onSuccess}
      >
        Please proceed to login
      </SweetAlert>
      }
      {isError
      && <SweetAlert
        warning
        title={catchError}
        onConfirm={onConfirm}
        timeout={10000}
      >
      </SweetAlert>}
    </>
  );
}

export default SetPassword;
